import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { fetchMySalons, searchBfLeads } from "@/lib/bf";

const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export default function BFListSalon({ value, onPick, admin = false, required = false }) {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { if (!admin) fetchMySalons().then(setRows).catch(() => {}); }, [admin]);
  useEffect(() => {
    if (!admin || q.trim().length < 2) return undefined;
    const t = setTimeout(() => searchBfLeads(q).then(setRows).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [admin, q]);
  if (value) {
    return (
      <div className="bf-lp-chosen" data-testid="bf-list-salon-chosen">
        <span><b>{value.salon}</b><small>{[value.admin_name, value.phone || "fără telefon", value.city].filter(Boolean).join(" · ")}</small></span>
        <button type="button" onClick={() => onPick(null)} data-testid="bf-list-salon-clear"><X size={14} /> Schimbă</button>
      </div>
    );
  }
  const t = norm(q.trim());
  const dg = q.replace(/\D/g, "");
  const hits = t.length < 2 ? [] : admin ? rows.slice(0, 10) : rows.filter((r) => norm([r.salon, r.admin_name, r.city, r.cui].join(" ")).includes(t) || (dg.length >= 3 && (r.phone || "").replace(/\D/g, "").includes(dg))).slice(0, 10);
  return (
    <div className="bf-lp" data-testid="bf-list-salon-pick">
      <label className="bf-stock-search"><Search size={15} /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder={required ? "Alege clientul: caută după nume, telefon, oraș" : "Către ce salon? Caută după nume, telefon, oraș (opțional)"} data-testid="bf-list-salon-search" /></label>
      {hits.length > 0 && <ul>{hits.map((r) => <li key={r.id}><button type="button" onClick={() => { onPick(r); setQ(""); }} data-testid={`bf-list-salon-opt-${r.id}`}><b>{r.salon}</b> <small>{[r.admin_name, r.phone, r.city].filter(Boolean).join(" · ")}</small></button></li>)}</ul>}
      {t.length >= 2 && !hits.length && <p className="st-hint" data-testid="bf-list-salon-none">{admin ? "Niciun salon găsit." : "Niciun salon de-al tău găsit."}</p>}
    </div>
  );
}
